<template>
    <el-button :round="round" :disabled="disabled" :icon="icon" :loading="loading" class="btn">
        {{ label }}
    </el-button>
</template>

<script lang="ts" setup>
import type { Component } from "vue";

export interface Props {
    label?: string;
    bgColor?: string;
    borderColor?: string;
    round?: boolean;
    disabled?: boolean;
    loading?: boolean;
    height?: string;
    width?: string;
    icon?: string | Component;
    border?: boolean;
    color?: string;
    size?: string;
    weight?: string;
}

const props = withDefaults(defineProps<Props>(), {
    label: "按钮",
    bgColor: "linear-gradient( 90deg, #FFE665 0%, #FFD500 100%)",
    borderColor: "#E6E6E6",
    round: true,
    disabled: false,
    loading: false,
    height: "40",
    width: "60",
    icon: undefined,
    border: false,
    color: "#1A1A1A",
    size: "14",
    weight: "500"
});

const btnWidth = computed(() => {
    return props.width + "px";
});

const btnHeight = computed(() => {
    return props.height + "px";
});

const textSize = computed(() => {
    return props.size + "px";
});

const btnBorder = computed(() => {
    return props.border ? "1px solid " + props.borderColor : "none";
});

const roundedCorner = computed(() => {
    return props.round ? "100px" : "4px";
});

</script>

<style lang="scss" scoped>
    .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: v-bind(roundedCorner);
        height: v-bind(btnHeight);
        width: v-bind(btnWidth);
        background: v-bind(bgColor);
        font-weight: v-bind(weight);
        font-size: v-bind(textSize);
        color: v-bind(color);
        border: v-bind(btnBorder) !important;
    }
</style>
